import { render, staticRenderFns } from "./business-cooperation.vue?vue&type=template&id=324b5c18&scoped=true&"
import script from "./business-cooperation.vue?vue&type=script&lang=ts&"
export * from "./business-cooperation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324b5c18",
  null
  
)

export default component.exports